import api from './api';

const salesOverviewService = {
  getOverview: async (params = {}) => {
    const response = await api.get('/sales/reports/overview', { params });
    return response.data;
  },
};

export default salesOverviewService;
